var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon",class:{ 'active': _vm.isActive },domProps:{"innerHTML":_vm._s(_vm.setIcon())}})
}
var staticRenderFns = []

export { render, staticRenderFns }